import { render, staticRenderFns } from "./SectionItemNew.vue?vue&type=template&id=d2a9526c&lang=pug&"
import script from "./SectionItemNew.vue?vue&type=script&lang=js&"
export * from "./SectionItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports